/**
 * Provides pluginHeaderActionsApiRef for hybrid mode so the auth plugin's
 * consent page (PageBlueprint) can render. Plugin-app does not provide this API;
 * we supply a no-op implementation (no header actions on the consent page).
 * We create the ref with the same id as core so useApi() finds our implementation.
 */
import {
  createFrontendModule,
  ApiBlueprint,
  createApiRef,
} from '@backstage/frontend-plugin-api';

const pluginHeaderActionsApiRef = createApiRef<{
  getPluginHeaderActions: (pluginId: string) => unknown[];
}>({ id: 'core.plugin-header-actions' });

const noOpPluginHeaderActionsApi = {
  getPluginHeaderActions: (_pluginId: string) => [] as unknown[],
};

export const pluginHeaderActionsApiCompatModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ApiBlueprint.make({
      name: 'plugin-header-actions',
      params: (defineParams) =>
        defineParams({
          api: pluginHeaderActionsApiRef,
          deps: {},
          factory: () => noOpPluginHeaderActionsApi,
        }),
    }),
  ],
});
